import React from "react";
const itemTypeMapping = {
  29: "Registration Fee",
  30: "Admission Kit & Digital Access",
  "01": "Tuition Fee",
  "04": "Tech + Exam Fee",
  "05": "Classroom Fee Service",
  12: "Security Deposit",
  13: "Tuition Fee",

};
const ItemDescription = ({ itemList, type, desc }) => {
  return (
    <div style={{ width: "257px", padding: "10px" }}>
      {itemList.map((item) => (
        <div key={item} className="d-flex  justify-content-between mb-1">
          <span className="text-bold">
            {type === "OTHER_CHARGES" ? desc : itemTypeMapping[item?.slice(-2)]}
          </span>
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};

export default ItemDescription;
